import { ILogService, ITimeoutService } from "angular"
import { $app } from "../play-candidato-mod"
import { TestService } from "src/_candidato/priv/services/test.service"
import { AccesoDatos } from "src/_candidato/comun/services/acceso-datos"

import "./play-app.scss"

class SideBarCtrl {
    $visible = false

    toggle() {
        this.$visible = !this.$visible
    }
}

class PlayAppComponentCtrl {
    private ts2: Date

    $visible: boolean = true

    editor = {
        panel: new SideBarCtrl(),
        menu: new SideBarCtrl(),
        formular: new SideBarCtrl()
    }

    constructor(
        private $log: ILogService,
        private $timeout: ITimeoutService,
        private TestService: TestService,
        private AccesoDatos: AccesoDatos
    ) {
        this.ts2 = new Date()
    }

    $onInit(): void {
        this.$log.info('[PlayAppComponentCtrl] onInit')

        // this.UniciService.empezarTarea(this.nuevaTarea())
    }

    // private nuevaTarea(): TareaDef {

    //     return TareaDef.fromDef({
    //         destinos: [],
    //         notas: "kaakkak"
    //     })
    // } 

    nueva() {

        this.$timeout(() => this.$visible = true, 50)

        this.TestService.testFormularios().then(datos =>
            this.$log.info("=====> ", datos))

        this.AccesoDatos.menuResource.findAll().then(datos =>
            this.$log.info("=====> findAll ", datos))
    }

    toggle() {

    }
}

$app.component("playApp", {
    bindings: {
    },
    controller: PlayAppComponentCtrl,
    template: require("./play-app.component.html")
})